import * as React from 'react';
import {clsx} from 'clsx';
import {Checkbox} from '../shadcn-components/checkbox';

type CheckboxInputProps = {
	text: string
	checked: boolean
	onCheckedChange: ((checked: boolean) => void);
	className?: string
	error?: string;
}

export const CheckboxInput = React.forwardRef<HTMLButtonElement, CheckboxInputProps>(
	function CheckboxInput({
		text,
		checked,
		onCheckedChange,
		className,
		error
	}, ref) {
		return (
			<div>
				<div className={clsx('flex items-center gap-[8px]', className)}>
					<p>{text}</p>
					<Checkbox checked={checked} onCheckedChange={onCheckedChange}/>
				</div>
				{error && (
					<p className="mt-[6px] px-[16px] text-[12px] text-error leading-3">{error}</p>
				)}
			</div>
		);
	}
);
